<template>
  <CafeteriaElistmentForm :typeEndPoint="'cafeteriaElistmentShow'" :dataParams="this.$route.params" />
</template>
<script>
import CafeteriaElistmentForm from '@/components/modules/cafeteria/enlistment/form'
export default {
  name: 'CafeteriaElistmentEdit',
  components: {
    CafeteriaElistmentForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/enlistment/edit.vue